import { put, call } from 'redux-saga/effects';
import { skillList, skillAdd, skillEdit, skillUpdate, skillDelete, subSectorList } from '../../../services/settings/superadmin/skillService';

import * as types from '../../../actions';

export function* skillListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(skillList, payload);
      yield put({ type: types.SUPERADMIN_SKILL_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.SUPERADMIN_SKILL_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  }

export function* skillAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(skillAdd, payload);
      yield put({ type: types.SUPERADMIN_SKILL_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.SUPERADMIN_SKILL_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
   }
}

export function* skillEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(skillEdit, payload);
    yield put({ type: types.SUPERADMIN_SKILL_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SUPERADMIN_SKILL_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* skillUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(skillUpdate, payload);
    yield put({ type: types.SUPERADMIN_SKILL_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SUPERADMIN_SKILL_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* skillDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(skillDelete, payload);
    yield put({ type: types.SUPERADMIN_SKILL_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SUPERADMIN_SKILL_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* superSubSectorListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(subSectorList, payload);
    yield put({ type: types.SUPERADMIN_SUBSECTOR_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SUPERADMIN_SUBSECTOR_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}